import React from "react"
import Footer from "../components/footer"
import Navigation from "../components/navigation"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SEO from "../components/seo"
import Image from '../images/FullSizeRender-about.png'


const About = () => (
  <Container fluid style={{backgroundColor:'#ffffff',height:'60vh'}}>
    <SEO title="Product Strategy UI/UX" />
    <Navigation ></Navigation> 
    <Container style={{backgroundColor:'', color:'#000000', zIndex:'-1'}} >
      <Row>
      <Col sm='8' md='6' className='align-self-center'>
      <h6 style={{color:'#000000'}}>Naren is a complete product leader and a complete design leader who specializes in creating cutting edge AI/ML & data products.</h6>
      </Col>  
      <Col sm='4' md='6' className='m-0 p-0 border-1'>
      <img src={Image} alt='profilepicture'style={{height: '53vh'}}/>
    </Col>
      </Row>
      </Container>


    <Container className='py-5 '>
    <Row >
    <Col className='text-align-start my-3 py-5'>
    <p><strong>“Competing without <span style={{ textDecoration: 'line-through'}}>software </span>machine learning is like competing without electricity.”</strong></p>
    <p>- Naval, {' '} retold by Naren.</p>
    </Col>
    </Row>
    
    <Row >
    <Col xs={12} md={4} className=' mb-5 pb-5'>
   <h6>ABOUT</h6> 

<p>Over the last 14 years I have worked on all aspects of a digital product, from rough ideas on paper to complete usable products, from interface design to product strategy from blue sky conceptualization to thin slice solutioning, from creating user journey flows to information architecture, from defining key product metrics to growth hacking. </p>

<p>One of the things I’ve noticed is that building a product is a journey, it is never done and everything can always be made better. </p>

<p>The impetus to make things better with good design, to me, is fundamental and this is what I strive to do, every day and each waking hour. Design just doesn't mean what a product looks like and feels like. Design is how a product works from the veneer to the bolts and nuts.</p>
    </Col>

    <Col xs={12} md={4} className=' mb-5 pb-5'>
    <h6>MEDIA & CERTIFICATIONS</h6> 
  <p>"Product Thinking 101" webinar presented to over 150+ audience on 10 June 2020. <a href="https://thoughtworks.wistia.com/medias/jg9ggu2o2e" target="_blank" rel="noopener noreferrer">
Click here for the webinar recording.</a></p>

<p><a href="https://uxplanet.org/product-thinking-101-1d71a0784f60" target="_blank" rel="noopener noreferrer">"Product Thinking 101"</a> article published on uxplanet publication on medium ranks number 1 on Google search for "product thinking 101" search term.</p>

<p><a href="https://uxplanet.org/how-can-we-design-an-intelligent-recommendation-engine-b9bb1db4d050" target="_blank" rel="noopener noreferrer">"How Can We ‘Design’ An Intelligent Recommendation Engine?"</a> article published on uxplanet publication on medium ranks number 1 on Google search for "intelligent recommendation engine" search term.</p>

<p><a href="https://graduation.udacity.com/confirm/ZJX6EHRA" target="_blank" rel="noopener noreferrer">"AI/ML Product Manager"</a> Nanodegree Certification</p>
    </Col>
    <Col xs={12} md={4} className=' mb-5 pb-5'>
    <h6>CONTACT</h6> 
    <p>Please feel free to email me at - naren.katakam@gmail.com if interested to collaborate, jam on emerging technology topics or for product and design talks worldwide.</p>

<p>I'm generally active on <a href="https://twitter.com/narenkatakam" target="_blank" rel="noopener noreferrer">Twitter </a>and my DMs are open.</p>
<p>For a more professional connection, here's my <a href="https://linkedin.com/narenkatakam" target="_blank" rel="noopener noreferrer">LinkedIn.</a></p>

<p>—</p>

    </Col>

    </Row>

    </Container>


    
    <Footer />
  </Container>

)

export default About



